var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0011 2C12.5534 2 13.0011 2.44772 13.0011 3V12.5313L15.8661 9.67155C16.257 9.28138 16.8901 9.28195 17.2803 9.67283C17.6705 10.0637 17.6699 10.6969 17.279 11.087L12.7076 15.6502C12.3172 16.0399 11.685 16.0399 11.2946 15.6502L6.72322 11.087C6.33234 10.6969 6.33177 10.0637 6.72194 9.67283C7.11211 9.28195 7.74528 9.28138 8.13615 9.67155L11.0011 12.5313V3C11.0011 2.44772 11.4488 2 12.0011 2ZM20 14.2044C20.5523 14.2044 21 14.6521 21 15.2044V18.8925C21 19.7003 20.696 20.4848 20.1396 21.0711C19.5815 21.6592 18.813 22 18 22H6C5.18696 22 4.41851 21.6592 3.86042 21.0711C3.30402 20.4848 3 19.7003 3 18.8925L3 15.2044C3 14.6521 3.44772 14.2044 4 14.2044C4.55228 14.2044 5 14.6521 5 15.2044V18.8925C5 19.2026 5.1174 19.4902 5.31115 19.6944C5.50321 19.8967 5.75218 20 6 20H18C18.2478 20 18.4968 19.8967 18.6889 19.6944C18.8826 19.4902 19 19.2026 19 18.8925V15.2044C19 14.6521 19.4477 14.2044 20 14.2044Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadWhite);
export default __webpack_public_path__ + "static/media/ic-download-white.adb0881ff0aff190e84780f216956d45.svg";
export { ForwardRef as ReactComponent };